import React from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Dropzone from 'proposals/components/dropzone/Dropzone'

const PREFIX = 'AddAttachments'

const classes = {
  buttonTitleContainer: `${PREFIX}-buttonTitleContainer`,
  button: `${PREFIX}-button`,
  attachmentUpload: `${PREFIX}-attachmentUpload`
}

const Root = styled('div')(({ theme: { spacing } }) => ({
  [`& .${classes.buttonTitleContainer}`]: {
    display: 'flex',
    alignItems: 'center'
  },

  [`& .${classes.button}`]: {
    marginLeft: spacing(2)
  },

  [`& .${classes.attachmentUpload}`]: {
    display: 'none'
  }
}))

type AddAttachmentsPropTypes = {
  disabled?: boolean
  addDropzoneFiles: (files: File[]) => void
}

const AddAttachments: React.FC<AddAttachmentsPropTypes> = ({ disabled = false, addDropzoneFiles }) => {
  const { t } = useTranslation()

  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      addDropzoneFiles(acceptedFiles)
    },
    [addDropzoneFiles]
  )

  return (
    <Root>
      <div className={classes.buttonTitleContainer}>
        <Typography sx={{ mb: 1 }} variant="body2">
          {t('attachments')}
        </Typography>
      </div>
      <Dropzone onDrop={onDrop} disabled={disabled} />
    </Root>
  )
}

export default AddAttachments
